import React from "react";
import { useFetchShockEvent } from "@/lib/hooks/shock-event";
import { useFetchVehicle } from "@/lib/hooks/vehicle";
import { useFetchVehicleType } from "@/lib/hooks/vehicle-type";
import { useFetchDepartment } from "@/lib/hooks/department";
import { useFetchIncidentUser } from "@/lib/hooks/user";
import { useFetchShift } from "@/lib/hooks/shift";
import { Card } from "@/components/ui/card";
import { OperatorDetails } from "@/components/ui/operator-details";
import { EventMetaCard } from "@/components/ui/event-meta-card";
import { Separator } from "@/components/ui/separator";
import { VehicleDetails } from "@/components/ui/vehicle-details";
import { useTranslation } from "react-i18next";

export type ImpactViolationProps = {
    shockEventId: string;
};

export const ImpactViolation = ({ shockEventId }: ImpactViolationProps): JSX.Element => {
    const { t } = useTranslation();
    const [shockEvent, isShockEventLoading] = useFetchShockEvent(shockEventId);

    const [user, isUserLoading] = useFetchIncidentUser(
        shockEvent?.userId,
        shockEvent?.vehicleId,
        shockEvent?.time,
    );
    const [userDepartment, isUserDepartmentLoading] = useFetchDepartment(user?.departmentId);
    const [shift, isShiftLoading] = useFetchShift(user?.shiftId);

    const [vehicle, isVehicleLoading] = useFetchVehicle(shockEvent?.vehicleId);
    const [vehicleType, isVehicleTypeLoading] = useFetchVehicleType(vehicle?.vehicleTypeId);
    const [vehicleDepartment, isVehicleDepartmentLoading] = useFetchDepartment(
        vehicle?.departmentId,
    );

    const loading =
        isShockEventLoading ||
        isUserLoading ||
        isUserDepartmentLoading ||
        isShiftLoading ||
        isVehicleLoading ||
        isVehicleTypeLoading ||
        isVehicleDepartmentLoading;

    return (
        <>
            <EventMetaCard shockEvent={shockEvent} loading={loading} />
            <Card>
                <OperatorDetails
                    title={t("component.operatorDetails.title.operator")}
                    user={user}
                    unknown={false}
                    department={userDepartment}
                    shift={shift}
                    badgeLabel={t("component.operatorDetails.badge.driver")}
                    loading={loading}
                />
                <Separator className="mx-4" />
                <VehicleDetails
                    department={vehicleDepartment}
                    vehicle={vehicle}
                    vehicleType={vehicleType}
                    loading={loading}
                />
            </Card>
        </>
    );
};
